/* eslint-disable func-names */
/* eslint-disable object-shorthand */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { formatGivenDate } from '../../../../shared/services/common-functions';

function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}
function getRowClass ( params ) {

    if ( params.data.bgColor === 1 ) {

        return 'selected-row-blue';

    }
    return null;

}
function itemBuildWeekData ( params ) {

    const buildWeek = formatGivenDate( params.data.itemBuildWeek, 'YYYY-MM-DD' );

    if ( buildWeek === '2000-01-01' ) {

        return 'Inventory';

    } if ( buildWeek === '2000-02-01' ) {

        return 'Rework';

    }
    return buildWeek;

}

const orderBuildWeekData = params => formatGivenDate( params.data.orderBuildWeek, 'YYYY-MM-DD' );
const rsdData = params => formatGivenDate( params.data.rsd, 'YYYY-MM-DD' );

function buildReportHeader ( data ) {

    if ( data === '2000-01-01' ) {

        return 'Build Week:  Inventory';

    } if ( data === '2000-02-01' ) {

        return 'Build Week: Rework';

    }
    return `Build Week:  ${data}`;

}
export const AllBundlesOrderedTable = props => {

    const colDefs = [

        {
            field: 'orderingCode',
            headerName: props.selectedFamilyType,
            sortable: true,
            filter: true,
            width: 110,
            pinned: 'left',
            cellRenderer: params => ( <Link to={`/${params.data.unitName}/reports/orders-using-bundles-by-constraint-week?family=${params.data.family}&beginweek=${formatGivenDate( Number( params.data.beginweek ), 'YYYY-MM-DD' )}&endweek=${formatGivenDate( Number( params.data.beginweek ), 'YYYY-MM-DD' )}&bundle=${params.value}`}>{params.value}</Link> )
        },
        {
            field: 'itemBuildWeek',
            headerName: 'Item Build Week',
            sortable: true,
            filter: true,
            width: 160,
            valueGetter: itemBuildWeekData
        },
        {
            field: 'totalCapacity',
            headerName: 'Total Cap',
            sortable: true,
            filter: true,
            width: 110,
            cellClassRules: {
                'atp-all-bundles-ordered-result-red-cell': 'x < 0'
            },
            cellRenderer: params => {

                if ( params.value > 99999 ) return ( <span>Infinite</span> );
                return ( <span>{params.value}</span> );

            }
        },
        {
            field: 'totalAvailability',
            headerName: 'Total Avail',
            sortable: true,
            filter: true,
            width: 120,
            cellClassRules: {
                'atp-all-bundles-ordered-result-red-cell': 'x < 0'
            },
            cellRenderer: params => {

                if ( params.value > 99999 ) return ( <span>Infinite</span> );
                return ( <span>{params.value}</span> );

            }
        },
        {
            field: 'forecast',
            headerName: 'Forecast',
            sortable: true,
            filter: true,
            width: 110,
            cellClassRules: {
                'atp-all-bundles-ordered-result-red-cell': 'x < 0'
            },
            cellRenderer: params => {

                if ( params.value > 99999 ) return ( <span>Infinite</span> );
                return ( <span>{params.value}</span> );

            }
        },
        {
            field: 'totalOrdered',
            headerName: 'Total Ordered',
            sortable: true,
            filter: true,
            width: 150,
            cellClassRules: {
                'atp-all-bundles-ordered-result-red-cell': 'x < 0'
            },
            cellRenderer: params => {

                if ( params.value > 99999 ) return ( <span>Infinite</span> );
                return ( <span>{params.value}</span> );

            }
        },
        {
            field: 'orderNumber',
            headerName: 'Order Number',
            sortable: true,
            filter: true,
            width: 150,
            cellRenderer: params => ( <Link to={`/${params.data.unitName}/order/information?ordernum=${params.data.orderNumber}`}>{params.value}</Link> )
        },
        {
            field: 'orderBuildWeek',
            headerName: 'Order Build Week',
            sortable: true,
            filter: true,
            width: 180,
            valueGetter: orderBuildWeekData
        },
        {
            field: 'orderStatus',
            headerName: 'Order Status',
            sortable: true,
            filter: true,
            width: 150
        },
        {
            field: 'orderKind',
            headerName: 'Order Kind',
            sortable: true,
            filter: true,
            width: 150
        },
        {
            field: 'orderWeight',
            headerName: 'Order Weight',
            sortable: true,
            filter: true,
            width: 150
        },
        {
            field: 'invSource',
            headerName: 'Inv Source',
            sortable: true,
            filter: true,
            width: 140
        },
        {
            field: 'rsd',
            headerName: 'RSD Date',
            sortable: true,
            filter: true,
            width: 110,
            valueGetter: rsdData
        },
        {
            field: 'shipMode',
            headerName: 'Ship Mode',
            sortable: true,
            filter: true,
            width: 130
        },
        {
            field: 'ltlInd',
            headerName: 'LTL Ind',
            sortable: true,
            filter: true,
            width: 110
        },
        {
            field: 'orderQty',
            headerName: 'Order Qty',
            sortable: true,
            filter: true,
            width: 110
        }
    ];
    return (
        <section className="atp-search-result-panel all-bundles-ordered-result-panel ">

            <div className="results-message-red-bg">
                {buildReportHeader( props.selectedBeginWeek )}
            </div>

            <div className="results-message ">
                {`Total Ordering Quantity:${props.totalOrder}`}
            </div>

            <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
                <AgGridReactComponent
                    reactNext={true}
                    columnDefs={colDefs}
                    rowData={props.results}
                    onGridReady={onGridReady}
                    getRowClass={getRowClass}
                />
            </div>

        </section>
    );

};

AllBundlesOrderedTable.propTypes = {
    results: PropTypes.array.isRequired,
    selectedBeginWeek: PropTypes.string.isRequired,
    selectedFamilyType: PropTypes.string.isRequired,
    totalOrder: PropTypes.string.isRequired
};
